var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "subpage-head" }, [
      _c("div", { staticClass: "container" }, [
        _c("h1", [_vm._v("Edit " + _vm._s(_vm.entity))])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "login-reg" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "log-box main" }, [
          _c(
            "form",
            {
              staticClass: "gen-form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.saveProfile($event)
                }
              }
            },
            [
              _c("div", { staticClass: "form-row" }, [
                _c("label", [_vm._v("Discount code")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.item.code,
                      expression: "item.code"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.item.code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.item, "code", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.entity == "DiscountCode"
                ? [
                    _c("div", { staticClass: "form-row" }, [
                      _c("label", [_vm._v("Active")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.active,
                              expression: "item.active"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "active",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "Yes" } }, [
                            _vm._v("Yes")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "No" } }, [
                            _vm._v("No")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row" }, [
                      _c("label", [_vm._v("Parent")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.parent,
                              expression: "item.parent"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "parent",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("(no parent)")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.types, function(parent) {
                            return parent.id != _vm.item.id
                              ? _c(
                                  "option",
                                  { domProps: { value: parent.id } },
                                  [_vm._v(_vm._s(parent.title))]
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.entity == "VideoGroup"
                ? [
                    _c("div", { staticClass: "form-row split" }, [
                      _c("div", [
                        _c("label", [_vm._v("30 days (USD)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.priceUsd,
                              expression: "item.priceUsd"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.priceUsd },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "priceUsd",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [_vm._v("30 days (regular price)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.priceEur,
                              expression: "item.priceEur"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.priceEur },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "priceEur",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row split" }, [
                      _c("div", [
                        _c("label", [_vm._v("90 days (USD)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.renewPriceUsd,
                              expression: "item.renewPriceUsd"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.renewPriceUsd },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "renewPriceUsd",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [_vm._v("90 days (regular price)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.renewPriceEur,
                              expression: "item.renewPriceEur"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.renewPriceEur },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "renewPriceEur",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row split" }, [
                      _c("div", [
                        _c("label", [_vm._v("180 days (USD)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.renewPrice2Usd,
                              expression: "item.renewPrice2Usd"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.renewPrice2Usd },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "renewPrice2Usd",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [_vm._v("180 days (regular price)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.renewPrice2Eur,
                              expression: "item.renewPrice2Eur"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.renewPrice2Eur },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "renewPrice2Eur",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row split" }, [
                      _c("div", [
                        _c("label", [_vm._v("1 year (USD)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.renewPrice3Usd,
                              expression: "item.renewPrice3Usd"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.renewPrice3Usd },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "renewPrice3Usd",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [_vm._v("1 year (regular price)")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.renewPrice3Eur,
                              expression: "item.renewPrice3Eur"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.renewPrice3Eur },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "renewPrice3Eur",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row" }, [
                      _c("br"),
                      _vm._v(" "),
                      _c("label", { staticClass: "checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.individual,
                              expression: "item.individual"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.item.individual)
                              ? _vm._i(_vm.item.individual, null) > -1
                              : _vm.item.individual
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.item.individual,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.item,
                                      "individual",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.item,
                                      "individual",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.item, "individual", $$c)
                              }
                            }
                          }
                        }),
                        _c("em"),
                        _vm._v(
                          "\n                Pay for individual videos\n              "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row" }, [
                      _c("label", [_vm._v("Video type")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.type,
                              expression: "item.type"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "type",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.types, function(opt) {
                          return _c("option", { domProps: { value: opt.id } }, [
                            _vm._v(_vm._s(opt.title))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.type2,
                              expression: "item.type2"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "type2",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.types, function(opt) {
                          return _c("option", { domProps: { value: opt.id } }, [
                            _vm._v(_vm._s(opt.title))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.type3,
                              expression: "item.type3"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "type3",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.types, function(opt) {
                          return _c("option", { domProps: { value: opt.id } }, [
                            _vm._v(_vm._s(opt.title))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.type4,
                              expression: "item.type4"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "type4",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.types, function(opt) {
                          return _c("option", { domProps: { value: opt.id } }, [
                            _vm._v(_vm._s(opt.title))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.type5,
                              expression: "item.type5"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "type5",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.types, function(opt) {
                          return _c("option", { domProps: { value: opt.id } }, [
                            _vm._v(_vm._s(opt.title))
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.type6,
                              expression: "item.type6"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.item,
                                "type6",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.types, function(opt) {
                          return _c("option", { domProps: { value: opt.id } }, [
                            _vm._v(_vm._s(opt.title))
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row form-row-img" }, [
                      _c("label", [_vm._v("Photo")]),
                      _vm._v(" "),
                      _vm.item.photo
                        ? _c("img", {
                            attrs: { src: "/files/" + _vm.item.photo, alt: "" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.photo
                        ? _c(
                            "label",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "margin-bottom": "15px"
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.removePhoto,
                                    expression: "removePhoto"
                                  }
                                ],
                                staticStyle: {
                                  width: "auto",
                                  height: "auto",
                                  display: "inline-block"
                                },
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.removePhoto)
                                    ? _vm._i(_vm.removePhoto, null) > -1
                                    : _vm.removePhoto
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.removePhoto,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.removePhoto = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.removePhoto = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.removePhoto = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" Remove\n              ")
                            ]
                          )
                        : _c("input", {
                            ref: "photoUpload",
                            attrs: { type: "file" }
                          })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row" }, [
                      _c("label", [_vm._v("Description")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.description,
                            expression: "item.description"
                          }
                        ],
                        domProps: { value: _vm.item.description },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0)
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-act" }, [
      _c("button", { staticClass: "lbtn" }, [_vm._v("Update")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }